import { useEffect } from 'react'

import { toast } from 'react-toastify'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useAttachments from '@hooks/useAttachments'
import useUppyAttachmentUpload from '@hooks/useUppyAttachmentUpload'

import type { AttachmentModel } from '@models/attachment'

const buildAttachmentTypeString = (attachment_type: string) => {
  if (attachment_type === 'public_link_logo') return 'Logo'
  if (attachment_type === 'public_link_cover_image') return 'Cover Image'
  return 'Brand Attachment'
}

const defaultState = {
  showImage: false,
}
interface UseBrandPublicLinkAttachmentsParams {
  brandId: number,
  closeModal: () => void,
  initAttachment: Partial<AttachmentModel>,
}

function useBrandPublicLinkAttachments(params: UseBrandPublicLinkAttachmentsParams) {
  const {
    brandId, closeModal, initAttachment, initAttachment: { attachment_type },
  } = params

  const [state, setState] = useSetState(defaultState)
  const { showImage } = state

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: brandId,
      attachable_type: 'Brand',
    },
  })
  const { filteredAttachments } = attachmentsPayload

  const publicLinkLogo = filteredAttachments.filter(attachment => attachment.attachment_type === 'public_link_logo')[0]
    || initAttachment

  const publicLinkCoverImage = filteredAttachments.filter(
    attachment => attachment.attachment_type === 'public_link_cover_image',
  )[0] || initAttachment

  const attachment = attachment_type === 'public_link_logo' ? publicLinkLogo : publicLinkCoverImage

  useEffect(() => {
    if (!initAttachment.id) setState({ showImage: false })
    else setState({ showImage: true })
  }, [initAttachment.cache_key])

  const uppy = useUppyAttachmentUpload({
    // @ts-expect-error TS2741
    attachmentParams: initAttachment,
    successCallback: () => {
      closeModal()
      toast(`${buildAttachmentTypeString(attachment_type!)} Attachment Created Successfully`)
    },
  }, [...Object.values(initAttachment)])

  return {
    attachment,
    attachmentTypeString: buildAttachmentTypeString(attachment_type!),
    attachmentUrl: digObject(attachment, 'links.original_url', ''),
    callbacks: {
      setState,
    },
    showImage,
    uppy,
  }
}

export default useBrandPublicLinkAttachments
